import Vue from "vue";

const success = (context, response) => {
  context.smallLoading = false;
  context.closeModal("#configure-igloohome-v2");
};

const failed = (context, error) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (context, apiKey) =>
  Vue.$http
    .post("igloohome/refresh", { apiKey })
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    })
    .catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/refreshIgloohomeV2.js